import Vuex from 'vuex'
import Vue from 'vue'

import createPersistedState from 'vuex-persistedstate'

import brand from './modules/brand'
import ipoOrder from './modules/ipoOrder'
import common from './modules/common'
import cent from './modules/cent'
import trade from './modules/trade'
import order from './modules/order'
import balance from './modules/balance'
import user from './modules/user'
import cashin from './modules/cashin'
import auth from './modules/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      paths: ['auth', 'user.user', 'user.kycStatus', 'user.payment', 'user.date', 'brand.brand'],
      storage: localStorage,
    }),
  ],
  modules: {
    auth,
    brand,
    common,
    cent,
    trade,
    order,
    balance,
    user,
    cashin,
    ipoOrder,
  },
})
